<section>
  <app-shared-loading *ngIf="loading"></app-shared-loading>
  <div class="general-title">
    <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
  </div>
  <app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
  </app-return-methods>

  <div class="contentBox">
    <div class="center col-3">
      <div class="info-logo-container">
        <img src="{{ information.logo }}" class="payment_method_no_interactive __method_brands" alt="Logo claroPay" />
      </div>
    </div>
    <div class="col-7">
      <div class="methodInfo">
        <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
        </app-return-methods>
        <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>

        <form class="principalForm" [formGroup]="form">
          <ng-container *ngIf="formStepOne; else formStepTwoOtp">
            <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('documentNumber') }">
              <mat-label>{{ 'forms-NumDoc-Input' | translation | async }}</mat-label>
              <input autocomplete="off"
                type="text" placeholder="{{ 'forms-NumDoc-Input' | translation | async }}"
                matInput name="documentNumber"
                minlength="4"
                maxlength="16"
                formControlName="documentNumber"
                [readonly]="isControlReadOnly('documentNumber')" />
            </mat-form-field>
            <!-- Validators -->
            <ng-container *ngFor="let validation of errorsMessages.documentNumber">
              <div class="error-message"
                *ngIf="form.get('documentNumber').hasError(validation.type) && (form.get('documentNumber').dirty || form.get('documentNumber').touched)">
                {{ validation.message }}
              </div>
            </ng-container>

            <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('documentType') }">
              <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
              <mat-select placeholder="{{ 'forms-TypeDoc-Input' | translation | async }}" formControlName="documentType"
                ngDefaultControl>
                <mat-option [value]="document.value"
                  *ngFor="let document of listOfDocuments"
                  [readonly]="isControlReadOnly('documentType')">
                  {{ document.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngFor="let validation of errorsMessages.documentType">
              <div class="error-message"
                *ngIf="form.get('documentType').hasError(validation.type) && (form.get('documentType').dirty || form.get('documentType').touched)">
                {{ validation.message }}
              </div>
            </ng-container>
            <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
          </ng-container>
          <ng-template #formStepTwoOtp>
            <ng-container *ngIf="daviplataUserFieldsOnOtpViewFf">
              <div>
                <div class="subtitle">{{ 'forms-TypeDoc-Input' | translation | async }}:</div>
              </div>
              <div class="app-copy-to-clipboard">
                <app-copy-to-clipboard
                  [value]="findDocumentType(form.get('documentType').value)?.text ?? form.get('documentType').value"></app-copy-to-clipboard>
              </div>
              <div class="app-copy-to-clipboard">
                <div class="subtitle">{{ 'forms-NumDoc-Input' | translation | async }}:</div>
              </div>
              <div>
                <app-copy-to-clipboard [value]="form.get('documentNumber').value"></app-copy-to-clipboard>
              </div>
            </ng-container>
            <div class="otpInfo">
              <ng-container *ngIf="showNewOtpMsg; else otpPrimaryTest">
                <p>{{ 'daviplata-confirm-purchase-title' | translation | async }}</p>
                <p>{{ 'daviplata-confirm-purchase-desc' | translation | async }}</p>
              </ng-container>

              <ng-template #otpPrimaryTest>
                <p>{{ 'daviplata-otp-info-label' | translation | async }}</p>
              </ng-template>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'daviplata-Integration-Otp-Title' | translation | async }}</mat-label>
              <input autocomplete="off" type="text"
                placeholder="{{ 'daviplata-Integration-Otp-Title' | translation | async }}" matInput name="codeOtp"
                [minlength]="otpMinMaxLength" [maxlength]="otpMinMaxLength" formControlName="codeOtp" />
            </mat-form-field>
            <ng-container *ngFor="let validation of errorsMessages.codeOtp">
              <div class="error-message"
                *ngIf="form.get('codeOtp').hasError(validation.type) && (form.get('codeOtp').dirty || form.get('codeOtp').touched)">
                {{ validation.message }}
              </div>
            </ng-container>

            <!-- count container -->
            <div class="counterTimer">
              <p>{{ counterTime }}</p>
            </div>
          </ng-template>
        </form>
      </div>
      <app-buttons-bar [valid]="completedForms()" [template]="template" [nameCustom]="buttonMessage"
        (CUSTOM)="daviplataPurchaseIntentionControl()" class="payButton"> </app-buttons-bar>
    </div>
  </div>
</section>
